import type { JSX } from "solid-js";

type Props = {
	activeSlide: number;
	animateSlides: () => boolean;
	children: JSX.Element;
};

/**
 * Track for the video panel carousel.
 * Contains the slides, hides those outside of the viewport.
 */
export const VideoPanelCarouselTrack = (props: Props) => {
	return (
		<div
			class="video-panel-carousel__track"
			classList={{
				"video-panel-carousel__track--animated": props.animateSlides(),
			}}
			style={{
				transform: `translateX(-${props.activeSlide * 100}%)`,
			}}
		>
			{props.children}
		</div>
	);
};
